import {layoutMarkup} from "../layout/layoutMarkup.js";
import {componentsHelper} from "../../helpers/componentsHelper.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import {accordionDefaultContent} from './accordionSectionDefaultContent';
import l10n from "../../../lang/locallang";

const accordionSection = (param, is_public = false) => {
    componentsHelper.updateLocalization(accordionDefaultContent);
    const { accordionTexts } = l10n;
    let imagePlaceholder = '../../images/editor/CG_623218874.jpeg';
    let defaultContentValue = {
        0: {
            id: '',
            title: accordionTexts[0].title,
            content: `<p>${accordionTexts[0].content}</p>`,
            order: 1,
            asset_id: componentsHelper.setAssetUniqueID(null, 0, param.id, 'image'),
            image_url: imagePlaceholder,
            image_caption: '',
            image_alt: '',
        },
        1: {
            id: '',
            title: accordionTexts[1].title,
            content: `<p>${accordionTexts[1].content}</p>`,
            order: 2,
            asset_id: '',
            image_url: '',
            image_caption: '',
            image_alt: '',
        },
        2: {
            id: '',
            title: accordionTexts[2].title,
            content: `<p>${accordionTexts[2].content}</p>`,
            order: 3,
            image_id: '',
            image_url: '',
            image_caption: '',
            image_alt: '',
        },
    }
    let tabsList = param.content && param.content.tabs ? Object.values(param.content.tabs) : defaultContentValue;
    //console.log(tabsList)
    let content = '';
    // Regex for removing extra wrapper from item content
    const regex = /<div class="fr-element fr-view"[\s\S]*?<\/div>/;
    const { addTitle, edit, remove, addImage, addNewItem } = l10n.editor;

    for (let key in tabsList) {
        if (tabsList.hasOwnProperty(key)) {
            let item = tabsList[key];
            // Validate item content
            if (typeof item['content'] !== 'string') {
                console.warn(`Skipping invalid content for item:`, item);
                continue; // Skip this item
            }
            // Clean for existing content and keep as it is for new content
            const itemContentMatchRegex = item['content'].match(regex);
            const textContent = itemContentMatchRegex && itemContentMatchRegex.length
                ? itemContentMatchRegex[0].replace(' contenteditable="true"', '')
                : item['content'];

            console.log('Cleaned Text Content:', textContent);

            content += `
                <div class="accordion-section-item ${!item.image_url ? '--no-img' : ''}" id="${item.id}" data-order="${item.order}">
                    <div class="accordion-section-item__header">
                        <h3 ${!is_public ? `class="editable-text" contenteditable="true" data-placeholder="${addTitle}"` : ''}>${item.title}</h3>
                        <button type="button" class="accordion-open"></button>
                    </div>
                    <div class="accordion-section-item__content">
                        <div class="text-content ${!is_public ? `fr-editor-paragraph` : ''}">
                            ${!is_public ? `${cleanHTMLTabs(item['content'])}` : `${cleanHTMLTabs(textContent)}`}
                        </div>
                        ${item.image_url ? `
                            <div class="img-content">
                                ${!is_public ? `
                                    <div class="img-content-controls">
                                        <button class="btn accordion-img-button-edit" data-hint="${edit}"><i class="icon icon-img_upload"></i></button>
                                        <button class="btn accordion-img-button-delete" data-hint="${remove}"><i class="icon icon-trash"></i></button>
                                    </div>
                                ` : ''}
                                <img src="${item.image_url}" alt="${item.image_alt}" data-asset-id="${item.asset_id}">
                            </div>
                        ` : ''}
                    </div>
                    ${!is_public ? `
                        <div class="accordion-section-item__controls">
                            <button class="btn accordion-button-delete" data-hint="${remove}"><i class="icon icon-trash"></i></button>
                            <button class="btn accordion-button-add-image" data-hint="${addImage}"><i class="icon icon-img_add"></i></button>
                        </div>
                    ` : ''}
                </div>
            `;
        }
    }
    param.class = param.class ? param.class : 'accordion-section editor-section';

    param.style = param.style ? param.style : '';
    param.section = 'accordionSection';

    param.component = `
        <div class="accordion-section-list">
            ${content}
        </div>
       ${!is_public ? `
            <div class="add-new-accordion">
                <button class="btn btn-add-accordion"><i class="icon icon-add"></i><span>${addNewItem}</span></button>
            </div>
        ` : ''}

    `;

    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}


function cleanHTMLTabs(html) {
    // Parse the HTML string into a DOM Document
    let parser = new DOMParser();
    let doc = parser.parseFromString(html, 'text/html');

    // Select all div elements with the class "fr-wrapper"
    let divs = doc.querySelectorAll('div.fr-wrapper');

    divs.forEach(function(div) {
        // Move all children out of the div
        while (div.firstChild) {
            div.parentNode.insertBefore(div.firstChild, div);
        }
        // Remove the div itself
        div.parentNode.removeChild(div);
    });

    // Serialize the DOM Document back to a string
    return doc.body.innerHTML;
}

export {accordionSection};
